import { render, staticRenderFns } from "./ReaderIcon.vue?vue&type=template&id=653ebae3&scoped=true"
import script from "./ReaderIcon.vue?vue&type=script&lang=js"
export * from "./ReaderIcon.vue?vue&type=script&lang=js"
import style0 from "./ReaderIcon.vue?vue&type=style&index=0&id=653ebae3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653ebae3",
  null
  
)

export default component.exports